export var Region;
(function (Region) {
    Region["US"] = "US";
    Region["CA"] = "CA";
    Region["EU"] = "EU";
})(Region || (Region = {}));
